import { FC, ReactElement, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Stack, Tab, Tabs } from "@mui/material";

import { POTENTIAL_TABS } from "@/constants";

const PotentialSavingTabs: FC = (): ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = useMemo(() => {
    const currentPath = location.pathname.split("/").pop() || "";
    const idx = POTENTIAL_TABS.findIndex((tab) => tab.link === currentPath);
    return idx === -1 ? 0 : idx;
  }, [location.pathname]);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    const tab = POTENTIAL_TABS[newValue];
    if (!tab) return;
    navigate(`/dashboard/potential/${tab.link}`);
  };

  return (
    <Stack
      spacing={0}
      sx={{
        margin: {
          xs: "-6px -10px 0 -10px",
          md: "-12px -20px 0 -20px",
        },
        width: {
          xs: "calc(100% + 20px)",
          md: "calc(100% + 40px)",
        },
      }}
    >
      <Box
        sx={(theme) => ({
          borderBottom: `1px solid ${theme.palette.divider}`,
          width: "100%",
        })}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ minHeight: 36, px: { xs: 2, md: 3 } }}
        >
          <Tabs
            value={activeTab}
            onChange={handleChange}
            sx={{
              minHeight: 36,
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.9rem",
                minHeight: 36,
                padding: "6px 12px",
                mr: 0.5,
                color: "text.secondary",
                "&:hover": {
                  color: "primary.main",
                  backgroundColor: "transparent",
                },
                "&.Mui-selected": {
                  color: "primary.main",
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "primary.main",
                height: 2,
                bottom: 0,
              },
            }}
          >
            {POTENTIAL_TABS.map((tab) => (
              <Tab
                key={tab.link}
                label={tab.text}
                sx={{ gap: 0.5, py: 0 }}
              />
            ))}
          </Tabs>
          {/* Spacer keeps future right-aligned actions balanced with tabs */}
          <Box sx={{ width: 32 }} />
        </Stack>
      </Box>
    </Stack>
  );
};

export default PotentialSavingTabs;

// Re-export the components for routing
export { default as FirstSale } from "./first-sale";
export { default as PreferentialOrigin } from "./preferential-origin";
export { default as FTZ } from "./ftz";
export { default as MTB } from "./mtb";
export { default as Exclusions } from "./exclusions";
